<!-- 客户管理 -- 往届生续费 -- 列表 -->
<template>
  <div>
    <list-template
        :current-page="page"
        :is-check-input-box="false"
        :isDownload="true"
        :loading="loading"
        :search-config="searchConfig"
        :table-config="tableConfig"
        :table-data="tableData"
        :total="total"
        @onChangePage="handleCurrentChange"
        @onExportAll="handleDown"
        @onExportData="onDownload"
        @onHandle="handleEdit"
        @onReset="onReset"
        @onSearch="onSearch"
    ></list-template>
  </div>
</template>

<script>
import {tableListMixin} from '@/utils/mixins'
import {setConfigOption} from '@/utils'
import {fileDownload, get_2025pack, getActualSchool, getAllGrade} from '@/api'
import ListTemplate from "@/components/pages/List.vue";

export default {
  components: {ListTemplate},
  _config: {"route": {"path": "list", "meta": {"title": "列表", "keepAlive": true}}},
  mixins: [tableListMixin],
  data() {
    return {
      searchConfig: [
        {
          prop: "student",
          placeholder: "搜索学生姓名",
        },
        {
          prop: "teacher",
          placeholder: "搜索当前客户归属招生老师",
        },
        {
          prop: 'status',
          tag: "select",
          placeholder: '筛选审批状态',
          options: [
            {value: 1, label: '待审批'},
            {value: 2, label: '已通过'},
            {value: 3, label: '已驳回'},
          ],
        },
        {
          prop: 'school_id',
          tag: "select",
          placeholder: '筛选校区',
          options: [],
        },
        {
          prop: 'grade_id',
          tag: "select",
          placeholder: '筛选报名年级',
          options: [],
        },
        {
          prop: 'order_type',
          tag: "select",
          placeholder: '筛选订单类型',
          options: [
            {value: 1, label: '预报名'},
            {value: 2, label: '正式报名'},
            {value: 3, label: '在校生续费'},
            {value: 4, label: '复读生正式报名'},
            {value: 5, label: '保过订单'},
            {value: 100, label: '其他费用缴纳'},
          ],
        },
        {
          prop: 'pack_type',
          tag: 'select',
          placeholder: '筛选套餐类型',
          options: []
        },
        {
          prop: 'is_by_stages', tag: 'select', placeholder: '筛选学生是否分期',
          options: [{label: '是', value: 1}, {label: '否', value: 0}, {label: '部分欠缴', value: 2}]
        },
        {
          prop: 'discount_dingtalk_approve_status', tag: 'select', placeholder: '筛选学生特批优惠钉钉审批状态',
          options: [{label: '审批中', value: 1}, {label: '已通过', value: 2}, {label: '已驳回', value: 3}, {label: '无需审批', value: 0}]
        },
        {
          prop: 'stages_dingtalk_approve_status', tag: 'select', placeholder: '筛选学生学费分期钉钉审批状态',
          options: [{label: '审批中', value: 1}, {label: '已通过', value: 2}, {label: '已驳回', value: 3}, {label: '无需审批', value: 0}]
        },
        {
          tag: 'datePicker',
          prop: 'date',
          property: {
            'value-format': 'yyyy-MM-dd',
            type: 'daterange',
            'range-separator': '至',
            'start-placeholder': '缴费开始日期',
            'end-placeholder': '缴费结束日期'
          }
        }
      ],
      tableConfig: [
        {
          prop: "status", label: "审批状态",
          render(row) {
            return `<div style="color: ${Number(row?.status) === 1 ? '#F6AD3C' : Number(row?.status) === 2 ? '#23C343' : '#F53F3F'}">${Number(row?.status) === 1 ? '待审批' : Number(row?.status) === 2 ? '已通过' : '已驳回'}</div>`
          }
        },
        {prop: "order_type_name", label: "订单类型"},
        {prop: "pack_type_name", label: "套餐类型"},
        {prop: "student_name", label: "学生姓名"},
        {prop: "school", label: "入账学校"},
        {prop: "grade_name", label: "报名年级"},
        {prop: "belong_teacher", label: "当前客户归属招生老师"},
        {prop: "is_by_stages", label: "学生是否分期"},
        {prop: "money_answer", label: "系统计算应缴总额"},
        {prop: "money_actual", label: "实缴金额"},
        {prop: "created_at", label: "订单创建时间"},
        {
          prop: "handle",
          label: "操作",
          width: "120rem",
          handle: true,
          render(row) {
            return Number(row?.status) === 1 ? ["审批"] : ['查看']
          }
        },
      ],
    }
  },
  created() {
    this.getConfig()
  },
  methods: {
    getConfig() {
      get_2025pack().then(res => {
        setConfigOption({list: this.searchConfig, data: res, key: 'pack_type'})
      })
      getActualSchool(100).then(res => {
        setConfigOption({list: this.searchConfig, data: res, key: 'school_id'})
      })
      getAllGrade().then(res => {
        setConfigOption({list: this.searchConfig, data: res, key: 'grade_id'})
      })
    },
    getData() {
      this.getDataApi('/zhaosheng/api/recruit-v2/order-offline/list')
    },

    onBeforeSearch(val) {
      const {date, ...rest} = val
      const data = {...rest}
      if (date) {
        const [payment_start_time, payment_end_time] = date
        data.payment_start_time = payment_start_time
        data.payment_end_time = payment_end_time
      }
      this.search = {...data}
    },

    handleEdit(row, text) {
      const {created_at, order_type} = row
      const created_date = new Date(created_at).getTime()
      const is2025Order = created_date > new Date('2025-05-01 00:00:00').getTime()
      const is2026Order = created_date > new Date('2026-05-01 00:00:00').getTime()
      // 1: '预报名订单', 2: '正式报名订单', 3: '在校生续费订单', 4: '复读生正式报名订单', 5: '保过订单', 7: '转学生正式报名订单', 8: '其他费用缴纳', 100: '其他费用缴纳'
      if (order_type === 3) {
        if (text.type === 'approve') {
          this.$router.push(`./edit-xf?id=${row.id}`)
        } else if (text.type === 'view') {
          const isOld = is2025Order ? 'xf' : 'old'
          this.$router.push(`./look-${isOld}?id=${row.id}`)
        }
        return
      }
      let path = '-old'
      if (order_type === 2) {
        path = is2026Order ? '-2026' : is2025Order ? '' : '-old'
      }
      // const isOld = (is2025Order && order_type === 2) ? '' : '-old'
      if (text.type === 'approve') {
        this.$router.push(`./edit${path}?id=${row.id}`)
      } else if (text.type === 'view') {
        this.$router.push(`./look${path}?id=${row.id}`)
      }
    },
    handleDown() {
      fileDownload('/zhaosheng/api/recruit-v2/order-offline/export-v2', {...this.search}, {name: '线下支付审批缴费明细', show: true})
    },

    onDownload() {
      fileDownload('/zhaosheng/api/recruit-v2/order-offline/export', {...this.search}, {name: '线下支付审批', show: true})
    }
  },
}
</script>

<style lang="scss" scoped>
.role-list {
  padding-top: 24rem;
}

.button {
  margin-left: 34rem;
  margin-bottom: 30rem;
  box-sizing: border-box;
  width: 90rem;
  height: 34rem;
  opacity: 1;
  border-radius: 4rem;
}

.table {
  margin-left: 32rem;
}


::v-deep .el-table--enable-row-transition .el-table__body td.el-table__cell {
  text-align: left;
  font-size: 14rem;
  font-weight: normal;
  height: 48rem;
  box-sizing: border-box;
  color: #333333;
}

.header {
  position: fixed;
  top: 120rem;
  left: 300rem;
  font-size: 16rem;
  font-weight: bold;
  line-height: 24rem;
  color: #333333;
  letter-spacing: 3.5rem;
}

.el-button--text {
  margin-right: 40rem;
  font-size: 14rem;
  font-weight: normal;
  color: #3491fa;
}
</style>
